import contact, { smmContact, livingEnglishContact } from '../../public/constants/contact.js'

export default contact
export { smmContact, livingEnglishContact }
